export default __webpack_public_path__ + "static/media/pencil-svgrepo-com.6f325ee5.svg";